import { useState, useEffect, useContext } from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import { FaLeaf } from "react-icons/fa";
import BlogCard from "../../../../components/customer/cards/blogCard/BlogCard";
import { BlogSectionSkeleton } from "../../../../components/general/skeleton/SkeletonBlock";
import "../../../../assets/css/customer/home/blogSection/BlogSection.css";
import fertilizerNPK from "../../../../assets/images/products/fertilizerNPK.webp";
import MyContext from "../../../../context/MyContext";
import Swal from "sweetalert2";
import axios from "axios";
const BlogSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [blogs, setBlogs] = useState([]);
  const { baseUrl, baseUrlForFiles } = useContext(MyContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // useEffect(() => {
  //   const t = setTimeout(() => setLoading(false), 1000);
  //   return () => clearTimeout(t);
  // }, []);
  const viewAllBlogs = () => {
    axios
      .get(`${baseUrl}/customer/blogs/viewAllBlogs`)
      .then((response) => {
        console.log(response.data);
        if (response.data.hasOwnProperty("error")) {
          setErrorMessage(response.data.error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          setBlogs(response.data.blog);
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Blogs cannot load",
        });
      });
  };

  useEffect(() => {
    viewAllBlogs();
    setLoading(false);
  }, []);
  // IDs 1–4 — match SingleBlogPage & BlogsList data
  // const blogs = [
  //   {
  //     id: 1,
  //     title: "DAP vs Urea: Which Fertilizer Gives the Best Results for Pakistani Crops?",
  //     image: fertilizerNPK,
  //     date: "April 5, 2025",
  //     category: "Fertilizers",
  //   },
  //   {
  //     id: 2,
  //     title: "Vermi Compost: A Sustainable Organic Solution for Healthier Soil",
  //     image:
  //       "https://images.unsplash.com/photo-1628352081506-83c43123ed6d?w=800&h=600&fit=crop",
  //     date: "March 28, 2025",
  //     category: "Compost",
  //   },
  //   {
  //     id: 3,
  //     title: "Confidor vs Regent: Choosing the Right Pesticide for Your Crops",
  //     image:
  //       "https://images.unsplash.com/photo-1560493676-04071c5f467b?w=800&h=600&fit=crop",
  //     date: "March 20, 2025",
  //     category: "Pesticides",
  //   },
  //   {
  //     id: 4,
  //     title: "High-Yield Corn Seeds: Tips for Successful Germination in Punjab",
  //     image:
  //       "https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=800&h=600&fit=crop",
  //     date: "March 10, 2025",
  //     category: "Seeds",
  //   },
  // ];

  // Group 2 cards per slide for desktop
  const desktopGroups = [];
  for (let i = 0; i < blogs.length; i += 2) {
    desktopGroups.push(blogs.slice(i, i + 2));
  }

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe) {
      setActiveIndex((prev) =>
        prev < desktopGroups.length - 1 ? prev + 1 : 0,
      );
    }
    if (isRightSwipe) {
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : desktopGroups.length - 1,
      );
    }
  };

  // Mouse drag for desktop
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState(null);
  const [dragEnd, setDragEnd] = useState(null);

  const onMouseDown = (e) => {
    setIsDragging(true);
    setDragEnd(null);
    setDragStart(e.clientX);
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    setDragEnd(e.clientX);
  };

  const onMouseUp = () => {
    if (!isDragging || !dragStart || !dragEnd) {
      setIsDragging(false);
      return;
    }
    const distance = dragStart - dragEnd;
    const isLeftDrag = distance > minSwipeDistance;
    const isRightDrag = distance < -minSwipeDistance;
    if (isLeftDrag) {
      setActiveIndex((prev) =>
        prev < desktopGroups.length - 1 ? prev + 1 : 0,
      );
    }
    if (isRightDrag) {
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : desktopGroups.length - 1,
      );
    }
    setIsDragging(false);
  };

  const onMouseLeave = () => {
    setIsDragging(false);
  };

  if (loading) return <BlogSectionSkeleton />;

  return (
    <section className="blog-section-new">
      <Container>
        <Row>
          {/* LEFT HEADER */}
          <Col lg={4} md={12} className="blog-header-col-new">
            <div className="blog-header-content-new">
              <div className="blog-label-new">
                <FaLeaf className="blog-label-icon-new" />
                <span>OUR BLOGS</span>
              </div>
              <h2 className="blog-main-title-new">
                Latest News From{" "}
                <span className="text-green-new">The Blogs</span>
              </h2>
            </div>
          </Col>

          {/* RIGHT CAROUSEL */}
          <Col lg={8} md={12}>
            <div
              className="blog-carousel-new d-none d-md-block"
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
              onMouseDown={onMouseDown}
              onMouseMove={onMouseMove}
              onMouseUp={onMouseUp}
              onMouseLeave={onMouseLeave}
              style={{ cursor: isDragging ? "grabbing" : "grab" }}
            >
              <Carousel
                activeIndex={activeIndex}
                onSelect={(i) => setActiveIndex(i)}
                indicators={false}
                controls={false}
                interval={4000}
                pause="hover"
                wrap
                touch={false}
              >
                {desktopGroups.map((group, idx) => (
                  <Carousel.Item key={idx}>
                    <Row className="g-4">
                      {group.map((blog, blogIdx) => (
                        <Col md={6} key={blog.id}>
                          <BlogCard
                            blog={{
                              ...blog,
                              image: `${baseUrlForFiles}/${blog.image}`,
                            }}
                            index={idx * 2 + blogIdx}
                          />
                        </Col>
                      ))}
                    </Row>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>

            {/* Mobile View - Single cards */}
            <div
              className="blog-carousel-mobile d-md-none"
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            >
              <Carousel
                activeIndex={activeIndex}
                onSelect={(i) => setActiveIndex(i)}
                indicators={false}
                controls={false}
                interval={4000}
                pause="hover"
                wrap
                touch={false}
              >
                {blogs.map((blog, idx) => (
                  <Carousel.Item key={blog.id}>
                    <BlogCard
                      blog={{
                        ...blog,
                        image: `${baseUrlForFiles}/${blog.image}`,
                      }}
                      index={idx}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>

            {/* Custom Dots Indicator */}
            <div className="custom-dots-indicator">
              {desktopGroups.map((_, idx) => (
                <button
                  key={idx}
                  className={`dot-indicator ${activeIndex === idx ? "active" : ""}`}
                  onClick={() => setActiveIndex(idx)}
                  aria-label={`Go to slide ${idx + 1}`}
                />
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BlogSection;
